import { useState } from 'react';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import Dropdown from 'components/CalendarPicker/Dropdown';
import DeleteButton from 'components/Button/DeleteButton';
import './styles.scss';

const REMINDER_TYPES = {
  0: { label: 'On Date', key: 'days', defaultValue: 0 },
  1: { label: 'Day(s) Before', key: 'days', defaultValue: 1 },
  2: { label: 'Week(s) Before', key: 'weeks', defaultValue: 1 },
  3: { label: 'Month(s) Before', key: 'months', defaultValue: 1 },
};

const reminderOptions = Object.values(REMINDER_TYPES).map(t => t.label);
const numbers = Array.from({ length: 15 }, (_, i) => i + 1);

const TaskReminder = ({
  reminders = [],
  createReminder,
  updateReminder,
  deleteReminder,
  taskId,
}) => {
  const [showReminderOptions, toggleReminderDropdown] = useState(false);

  const show = () => {
    toggleReminderDropdown(true);
  };

  const dismiss = () => {
    toggleReminderDropdown(false);
  };

  const handleCreateReminder = (typeIndex) => {
    const type = REMINDER_TYPES[typeIndex];
    createReminder(taskId, {
      spec: {
        delta: { [type.key]: type.defaultValue },
      },
    });
    toggleReminderDropdown(false);
  };

  const updateReminderValue = (reminderTaskId, definitionId, value, key) => {
    let newValue = value;
    // If switching from "On Date" to another value, force value to be 1
    if (newValue === 0 && key !== 'days') {
      newValue = 1;
    }
    updateReminder(reminderTaskId, definitionId, {
      spec: {
        delta: {
          [key]: newValue,
        },
      },
    });
  };

  const removeReminder = (reminderTaskId, definitionId) => {
    deleteReminder(reminderTaskId, definitionId);
  };

  const renderReminderOptions = () => {
    return (
      <>
        {Object.keys(REMINDER_TYPES).map(typeIndex => (
          <button
            key={typeIndex}
            className="ap-dropdown__button ap-dropdown__button--reminder button--unstyled"
            onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              handleCreateReminder(typeIndex);
            }}
          >
            {REMINDER_TYPES[typeIndex].label}
          </button>
        ))}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--reminder">
      Add
    </DropdownButton>
  );

  return (
    <>
      <div className="reminder-heading">REMINDERS</div>

      {reminders.length > 0 && (
        <div className="reminder-list">
          {reminders.map(reminder => {
            const { taskId: reminderTaskId, definitionId, delta } = reminder;
            const type = delta.days ? delta.days > 0 ? 1 : 0 : delta.weeks ? 2 : delta.months ? 3 : 0;
            const numericValue = delta.days ?? delta.weeks ?? delta.months;
            const updateValue = numericValue < 1 ? 1 : numericValue;

            return (
              <div
                key={reminder.definitionId}
                className="reminder-item"
              >
                <div className="reminder-item__count">
                  {(delta.days > 0 || delta.weeks || delta.months) && (
                    <Dropdown
                      options={numbers}
                      value={numericValue}
                      nShowItems={10}
                      onChangeValue={(newValue) => {
                        updateReminderValue(reminderTaskId, definitionId, newValue, REMINDER_TYPES[type].key);
                      }}
                    />
                  )}
                </div>

                <Dropdown
                  options={reminderOptions}
                  value={REMINDER_TYPES[type].label}
                  nShowItems={4}
                  onChangeValue={(newValue) => {
                    const key = Object.keys(REMINDER_TYPES).find(t => REMINDER_TYPES[t].label === newValue);
                    if (key) {
                      updateReminderValue(
                        reminderTaskId, definitionId, key === '0' ? 0 : updateValue, REMINDER_TYPES[key].key,
                      );
                    }
                  }}
                />

                <div
                  className="reminder-item__remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeReminder(reminderTaskId, definitionId);
                  }}
                >
                  <DeleteButton />
                </div>
              </div>
            );
          })}
        </div>
      )}

      <APResponsiveDropdown
        opened={showReminderOptions}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="reminder-dropdown"
        root={null}
      >
        {renderReminderOptions()}
      </APResponsiveDropdown>
    </>
  );
};

export default TaskReminder;
